<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 复用Header组件 -->
    <Header />
    
    <!-- 主要内容 -->
    <div class="container mx-auto py-6">
      <!-- 面包屑导航 -->
      <div class="mb-6">
        <div class="flex items-center text-sm bg-white px-4 py-3 rounded-lg shadow-sm">
          <router-link to="/" class="text-gray-500 hover:text-blue-600">网站首页</router-link>
          <span class="mx-2 text-gray-400">/</span>
          <span class="text-blue-600 font-medium">会员风采</span>
        </div>
      </div>
      
      <!-- 筛选菜单 -->
      <div class="mb-6">
        <div class="flex items-center space-x-2 bg-white p-2 rounded-lg shadow-sm">
          <button 
            class="px-4 py-2 rounded-md transition-all" 
            :class="activeFilter === 'director' ? 'bg-blue-600 text-white font-medium' : 'text-gray-700 hover:bg-gray-100'"
            @click="activeFilter = 'director'"
          >
            理事单位
          </button>
          <button 
            class="px-4 py-2 rounded-md transition-all" 
            :class="activeFilter === 'new' ? 'bg-blue-600 text-white font-medium' : 'text-gray-700 hover:bg-gray-100'"
            @click="activeFilter = 'new'"
          >
            新会员单位
          </button>
        </div>
      </div>
      
      <!-- 会员列表区域 -->
      <div class="flex justify-center">
        <!-- 会员列表 -->
        <div class="max-w-5xl w-full">
          <!-- 会员卡片 -->
          <div 
            v-for="member in filteredMembers" 
            :key="member.id"
            class="member-card flex flex-col md:flex-row"
          >
            <div class="member-logo w-full md:w-48 h-48 md:h-auto bg-gray-100 rounded-md flex items-center justify-center mb-4 md:mb-0 md:mr-6">
              <div class="text-gray-500">企业logo图</div>
            </div>
            <div class="member-info flex-1">
              <div class="flex items-center justify-between mb-4">
                <h3 class="member-name text-xl font-semibold text-gray-800">{{ member.name }}</h3>
              </div>
              <p class="member-description text-gray-600 mb-4 line-clamp-3">{{ member.description }}</p>
              <router-link :to="'/member/' + member.id" class="text-blue-600 hover:text-blue-800 transition-colors font-medium">
                查看详情 →
              </router-link>
            </div>
          </div>
          
          <!-- 分页 -->
          <div class="pagination flex justify-center items-center mt-8 space-x-2">
            <button 
              class="page-item py-2 px-4 border border-gray-300 rounded-md disabled:opacity-50 bg-white hover:bg-gray-50 transition-colors"
              :disabled="currentPage === 1"
              @click="prevPage"
            >
              <i class="fa fa-chevron-left mr-1"></i> 上一页
            </button>
            <button 
              v-for="page in visiblePages" 
              :key="page"
              class="page-item py-2 px-4 rounded-md transition-colors"
              :class="page === '...' ? 'cursor-default border-none bg-transparent' : (currentPage === page ? 'bg-blue-600 text-white' : 'border border-gray-300 bg-white hover:bg-gray-50')"
              :disabled="page === '...'"
              @click="page !== '...' && goToPage(page)"
            >
              {{ page }}
            </button>
            <button 
              class="page-item py-2 px-4 border border-gray-300 rounded-md bg-white hover:bg-gray-50 transition-colors"
              :disabled="currentPage === totalPages"
              @click="nextPage"
            >
              下一页 <i class="fa fa-chevron-right ml-1"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'

export default {
  name: 'MemberList',
  components: {
    Header,
    AppFooter
  },
  data() {
    return {
      activeFilter: 'director', // 默认展示理事单位
      currentPage: 1,
      totalPages: 5,
      members: [
        {
          id: 1,
          name: '吉林省启明信息技术股份有限公司',
          description: '吉林省启明信息技术股份有限公司成立于2000年4月，是国内领先的汽车行业IT解决方案提供商，专注于汽车产业全价值链的数字化转型，为汽车制造商、零部件供应商等提供全方位的信息化服务。',
          type: 'director'
        },
        {
          id: 2,
          name: '吉林用友软件有限公司',
          description: '吉林用友软件有限公司作为用友集团在东北地区的重要分支机构，专注于为吉林省内企业提供财务管理、ERP系统、数字营销等全方位的企业信息化解决方案，助力企业数字化转型。',
          type: 'director'
        },
        {
          id: 3,
          name: '长春易加科技有限公司',
          description: '长春易加科技有限公司是一家专注于智能制造和工业互联网领域的高新技术企业，致力于为制造业企业提供数字化工厂解决方案、工业软件定制开发等服务，推动制造业数字化转型。',
          type: 'director'
        },
        {
          id: 4,
          name: '长春金蝶软件有限公司',
          description: '长春金蝶软件有限公司是金蝶国际软件集团在吉林地区的分支机构，专注于为中小企业提供财务云、供应链云、制造云等企业级SaaS服务，助力企业降本增效，实现数字化管理。',
          type: 'director'
        },
        {
          id: 5,
          name: '长春国信优易数据有限公司',
          description: '长春国信优易数据有限公司是一家专注于大数据技术研发与应用的企业，为政府、企业提供大数据分析、数据治理、人工智能应用等服务，助力数字吉林建设。',
          type: 'director'
        },
        {
          id: 6,
          name: '吉林省新会员科技有限公司',
          description: '吉林省新会员科技有限公司是一家专注于人工智能技术研发的创新型企业，致力于为各行业提供智能化解决方案，推动行业数字化转型。',
          type: 'new'
        },
        {
          id: 7,
          name: '长春创新软件有限公司',
          description: '长春创新软件有限公司是一家专注于软件开发和IT服务的企业，为客户提供定制化的软件解决方案和技术支持服务。',
          type: 'new'
        }
      ]
    }
  },
  computed: {
    filteredMembers() {
      return this.members.filter(member => member.type === this.activeFilter)
    },
    visiblePages() {
      const total = this.totalPages
      const current = this.currentPage
      const maxVisible = 5
      if (total <= maxVisible) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      const pages = []
      if (current <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i)
        pages.push('...')
        pages.push(total)
      } else if (current >= total - 2) {
        pages.push(1)
        pages.push('...')
        for (let i = total - 3; i <= total; i++) pages.push(i)
      } else {
        pages.push(1)
        pages.push('...')
        for (let i = current - 1; i <= current + 1; i++) pages.push(i)
        pages.push('...')
        pages.push(total)
      }
      return pages
    }
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    goToPage(page) {
      this.currentPage = page
    }
  }
}
</script>

<style scoped>
.member-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e2e8f0;
  padding: 20px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.member-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #4B60E7;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.member-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: #4B60E7;
}

.member-card:hover::before {
  opacity: 1;
}

.member-name {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.member-description {
  color: #64748b;
  line-height: 1.6;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>